// extracted by mini-css-extract-plugin
export var messageSideLeft = "_k4-1";
export var messageSideRight = "_k4-2";
export var orderLookupBubbleContainer = "_k4-0";
export var submitButton = "_k4-3";